<div fxLayout="row wrap" fxLayout.xs="column wrap" fxLayoutAlign="start start">
  <mat-card *ngFor="let item of taskItems" 
    fxFlex.gt-xs="50%" 
    fxFlex.gt-md="32%"
    style="margin-top: 3px; margin-right: 3px;flex-grow: 0;flex-basis: 0;width:fit-content;"
    [class.mat-elevation-z7]='true'>
    
    <mat-card-title style="font-size: 16px; font-weight: 500; width: 220px;height: 30px;">
      {{item.name}}
    </mat-card-title>

    <div *ngIf="item.statusCode === 700000000 else loadSubmittedPhoto" style="margin-top: 6px;">

      <div fxHide.gt-sm fxShow.lt-md style="height: 100px; width: 220px; background-color: #f6f6f6;">
        <img *ngIf="waitForFileToUpload[lookupIndex(item)] === false" 
          [src]="promptUploadImage" alt="{{'waiting for upload: ' + item.name}}"
          style="height: 100px; width:100px; display: block; margin: auto;"/>
      </div>

      <div *ngIf="waitForFileToUpload[lookupIndex(item)] !== false && fileError !== true" style="margin-top: 12px;">
        <mat-progress-bar mode="indeterminate" style="width: 100%;"></mat-progress-bar>
      </div>

      <div>
        <div *ngIf="(checkUploadAuthorization(item) === 1 || checkUploadAuthorization(item) === 2) else showUploadPhoto">
          <p
            *ngIf="checkUploadAuthorization(item) === 1" 
            style="margin-bottom: 6px;">
            Submitted to EBB
          </p>
          <p
            *ngIf="checkUploadAuthorization(item) === 2" 
            style="margin-top: 12px; margin-bottom: 12px;">
            READ-ONLY
          </p>
          <p
            *ngIf="checkUploadAuthorization(item) === 1 && item.statusCode !== 700000001" 
            style="margin-top: 11px; margin-bottom: 12px;">
            NO ACTION REQUIRED
          </p>
          <p
            *ngIf="checkUploadAuthorization(item) === 1 && item.statusCode === 700000001" 
            style="margin-top: 11px; margin-bottom: 12px;">
            APPROVED
          </p>
        </div>
      
      

        <ng-template  #showUploadPhoto style="margin-top: 12px;">
            <div  fxHide.gt-sm fxShow.lt-md  >
          <p style="margin-top: 14px; margin-bottom: 6px;">
            Please submit a photo
          </p>
        </div>
          <div fxShow.gt-sm fxHide.lt-md *ngIf="waitForFileToUpload[lookupIndex(item)] === false"  (click)="onUploadPhotoEvent(item)" class="col-12 rmpm" style=" min-height: 100px;min-width: 200px;display: table;width: 100%;background-color: #eee; border: dotted 1px #aaa;" appDrag (files)="filesDropped($event,item)">
            <div class="text-wrapper">
              <img
                [src]="promptUploadImage" alt="{{'waiting for upload: ' + item.name}}"
                style="height: 100px; width:100px; display: block; margin: auto;"/>
              <div style="text-align: center;"> Drop image here or click to upload</div>
            </div>
          </div>
          <!-- <p style="margin-top: 14px; margin-bottom: 6px;">
            Please submit a photo
          </p> -->
          <div style="display: inline-block;">
          <button mat-raised-button color="primary" 
            id="{{formatNameToId(item.name)}}-upload"
            *ngIf="waitForFileToUpload[lookupIndex(item)] === false"
            (click)="onUploadPhotoEvent(item)" style="font-size: 12px;">
            UPLOAD PHOTO
          </button>
          
          <p  fxShow.gt-sm fxHide.lt-md *ngIf="checkcookie(item.id)" class="mat-error"><mat-icon>warning</mat-icon> {{getCookie(item.id)}}</p>
         
        </div>
      <div *ngIf="item.isRequired === false" style="display: inline-block;  float: right;margin-right: 4px;">
          <button  mat-raised-button color="primary" 
          id="{{formatNameToId(item.name)}}-upload-notneed"
          *ngIf="waitForFileToUpload[lookupIndex(item)] === false"
          (click)="onUploadNAPhotoEvent(item)" style="font-size: 12px;">
          NOT NEEDED
        </button>
      </div>
        </ng-template>
        <span *ngIf="waitForFilesToShow===true">
          UPLOADING...
        </span>
      </div>
    </div>

    <ng-template #loadSubmittedPhoto>
      <div *ngIf="item.statusCode === 700000001" >
        <div class="text-wrapper">
      <a href="javascript:void(0)" (click)="onViewFileEvent(2, item.id)">
        
        <img *ngIf="lookupSubmittedPhoto(item.payload).fileShow" 
          src="{{lookupSubmittedPhoto(item.payload).file}}"  alt="{{'photo for ' + item.name}}"
          style="max-height:100px; max-width:240px; display: block; margin: auto;"/>
      </a>
    </div>
    </div>
      <div *ngIf="!waitForFilesToShow && checkUploadAuthorization(item) === 3 && item.statusCode !== 700000001" 
      style="margin-top: 6px; height: 102px; width: 220px; background-color: #f6f6f6; border:#29637C; border-width: 1px; border-style: solid;">
      <div   (click)="onUploadPhotoEvent(item)" class="col-12 rmpm" style=" min-height: 100px;min-width: 200px;display: table;width: 100%;background-color: #eee; border: dotted 1px #aaa;" appDrag (files)="filesDropped($event,item)">
        <div class="text-wrapper">
      <a href="javascript:void(0)" (click)="onViewFileEvent(2, item.id)">
        
        <img *ngIf="lookupSubmittedPhoto(item.payload).fileShow" 
          src="{{lookupSubmittedPhoto(item.payload).file}}"  alt="{{'photo for ' + item.name}}"
          style="max-height:100px; max-width:240px; display: block; margin: auto;"/>
      </a>
    </div>
  </div>


    </div>
    <div *ngIf="waitForFileToUpload[lookupIndex(item)] === false && checkUploadAuthorization(item) !== 3 && item.statusCode !== 700000001" 
    style="margin-top: 6px; height: 102px; width: 220px; background-color: #f6f6f6; border:#29637C; border-width: 1px; border-style: solid;">
    <a href="javascript:void(0)" (click)="onViewFileEvent(2, item.id)">
      <img *ngIf="lookupSubmittedPhoto(item.payload).fileShow" 
        src="{{lookupSubmittedPhoto(item.payload).file}}"  alt="{{'photo for ' + item.name}}"
        style="max-height:100px; max-width:240px; display: block; margin: auto;"/>
    </a>
  </div>
      <div *ngIf="waitForFileToUpload[lookupIndex(item)] !== false" style="margin-top: 12px;">
        <mat-progress-bar mode="indeterminate" style="width: 100%;"></mat-progress-bar>
      </div>


      <div 
        *ngIf="(checkUploadAuthorization(item) === 1 || checkUploadAuthorization(item) === 2)
                else displayPhotoItemAction">
        <div style="margin-top: 12px;">
          <p
            *ngIf="checkUploadAuthorization(item) === 1" 
            style="margin-bottom: 6px;">
            Submitted to EBB
          </p>
          <div [ngClass]="'buttonAlignContainer'">
            <div style="height: 36px; padding-top: 9px; font-size: 14px;"
              *ngIf="checkUploadAuthorization(item) === 2" 
              style="margin-top: 12px; margin-bottom: 12px;">
              READ-ONLY
            </div>
            <div style="height: 36px; padding-top: 9px; font-size: 14px;"
              *ngIf="checkUploadAuthorization(item) === 1 && item.statusCode !== 700000001">
              NO ACTION REQUIRED
            </div>
            <div style="height: 36px; padding-top: 9px; font-size: 14px;"
              *ngIf="checkUploadAuthorization(item) === 1 && item.statusCode === 700000001">
              APPROVED
            </div>
            <button *ngIf="item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate"
              matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
              mat-icon-button aria-label="Upload information" color="primary"
              style="height: 24px; width: 24px;">
              <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <ng-template #displayPhotoItemAction>
        <div [ngSwitch]="item.statusCode"
          style="margin-top: 12px;">
          <div *ngSwitchCase="700000001">
            <p style="margin-bottom: 6px;">
              {{item.statusCodeOptionSet}} by EBB
            </p>
            <div [ngClass]="'buttonAlignContainer'">
              <button mat-flat-button>
                NO ACTION REQUIRED
              </button>
              <button *ngIf="item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate" 
                matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                mat-icon-button aria-label="Upload information" color="primary"
                style="height: 24px; width: 24px;">
                <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
              </button>
            </div>
          </div>
          <div *ngSwitchCase="700000002">
            <p class="warn-text" style="margin-bottom: 6px;">
              Action required 
              <span *ngIf='item.reasonWhy' style="color: black">
                (<a style='color: #29637C; font-size: 16px; font-weight: 400;'
                href="javascript:void(0)"
                 (click)='onClickShowReasonWhy(item.reasonWhy)'>read why</a>)
              </span>
            </p>
            <div [ngClass]="'buttonAlignContainer'">
           
              <button mat-stroked-button color="primary" 
                id="{{formatNameToId(item.name)}}-uploadreplacement"
                (click)="onUploadPhotoEvent(item)">
                UPLOAD REPLACEMENT
              </button>
              <button *ngIf="item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate" 
                matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                mat-icon-button aria-label="Upload information" color="primary"
                style="height: 24px; width: 24px;">
                <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
              </button> 
            </div>
            <p  fxShow.gt-sm fxHide.lt-md *ngIf="checkcookie(item.id)" class="mat-error"><mat-icon>warning</mat-icon> {{getCookie(item.id)}}</p>

          </div>
          <div *ngSwitchCase="700000003">
            <p style="margin-bottom: 6px;">
              Waiting for review by EBB
            </p>
            <div [ngClass]="'buttonAlignContainer'">
              <button mat-stroked-button color="primary" 
                id="{{formatNameToId(item.name)}}-uploadreplacement"
                (click)="onUploadPhotoEvent(item)">
                UPLOAD REPLACEMENT
              </button>
              <button *ngIf="item.ebbModifiedByTypeOptionSet && item.ebbModifiedDate" 
                matTooltip="{{item.ebbModifiedByTypeOptionSet}} Update, Date: {{item.ebbModifiedDate | date:'MM/dd/yyyy':'PST'}}"
                mat-icon-button aria-label="Upload information" color="primary"
                style="height: 24px; width: 24px;">
                <mat-icon style="font-size: 24px; margin-top: -18px;">info</mat-icon>
              </button>
            </div>
            <p  fxShow.gt-sm fxHide.lt-md *ngIf="checkcookie(item.id)" class="mat-error"><mat-icon>warning</mat-icon> {{getCookie(item.id)}}</p>

          </div>
        </div>
      </ng-template>
    </ng-template>
  </mat-card>
</div>
